// @flow
import React, { Component } from 'react';
import uuid from 'uuid/v1';
import { Wrapper } from './style';

type Props = {
    label: string,
    value: string,
    checked: boolean,
    onChange: (value: string) => void,
    name: string
};

class Radio extends Component<Props> {
    handleChange = () => {
        const { value, onChange } = this.props;
        onChange(value);
    };

    render() {
        const { label, checked, name } = this.props;
        const id = uuid();

        return (
            <Wrapper>
                <div className="radio-container">
                    <label htmlFor={id} className="label--radio">
                        <input
                            type="radio"
                            id={id}
                            name={name}
                            className="radio"
                            checked={checked}
                            onChange={this.handleChange}
                        />
                        <div>{label}</div>
                    </label>
                </div>
            </Wrapper>
        );
    }
}

export default Radio;



// WEBPACK FOOTER //
// ./src/components/Radio/index.js